// Import necessary libs
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "react-oidc-context";
import { User, WebStorageStateStore } from "oidc-client-ts";

// Import environment utilities
import { getEnvVar } from './utils/environment';

// Log all available environment variables to help with debugging
if (process.env.REACT_APP_DEBUG === 'true') {
  console.log('Debug mode enabled');
  console.log('Environment variables:', process.env);
}

// OIDC Configuration for auth - construct the URLs correctly
const cognitoDomain = getEnvVar('REACT_APP_COGNITO_DOMAIN');
const clientId = getEnvVar('REACT_APP_CLIENT_ID');
// region is not currently used but may be needed in the future
// const region = getEnvVar('REACT_APP_AWS_REGION');

// OIDC Configuration for auth
const oidcConfig = {
  authority: `https://${cognitoDomain}`,
  client_id: clientId,
  redirect_uri: `${window.location.origin}/auth/callback`,
  onSigninCallback: (_user: User | void): void => {
    // After successful login, check if we have an original path to redirect to
    const originalPath = localStorage.getItem('originalPath');
    console.log("Original path from localStorage:", originalPath);
    
    // Clear the stored path immediately to prevent any loop issues
    localStorage.removeItem('originalPath');
    
    // If original path is login or signup, or doesn't exist, redirect to dashboard
    if (!originalPath || originalPath === '/login' || originalPath === '/signup') {
      console.log("Redirecting to dashboard");
      window.location.replace('/dashboard');
    } else {
      console.log("Redirecting to original path:", originalPath);
      // Use replace instead of pushState to avoid breaking the back button
      window.location.replace(originalPath);
    }
  },
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // Add explicit metadata to avoid CORS issues
  metadata: {
    issuer: `https://${cognitoDomain}`,
    authorization_endpoint: `https://${cognitoDomain}/oauth2/authorize`,
    token_endpoint: `https://${cognitoDomain}/oauth2/token`,
    end_session_endpoint: `https://${cognitoDomain}/logout`,
    jwks_uri: `https://${cognitoDomain}/.well-known/jwks.json`,
    userinfo_endpoint: `https://${cognitoDomain}/oauth2/userInfo`
  }
};

// Authentication configuration is set up with values from environment variables

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <AuthProvider {...oidcConfig}>
        <App />
      </AuthProvider>
    </React.StrictMode>
  );
}

window.addEventListener("error", (event: ErrorEvent) => {
  if (
    event.message &&
    event.message.includes("ResizeObserver loop completed with undelivered notifications")
  ) {
    event.preventDefault();
    // Optionally, return true to signal that the error is handled.
    return true;
  }
});
